import React, {useId} from 'react';

import {RequiredMark} from 'src/components/required-mark';

import {FieldDescription, Types as FieldDescriptionTypes} from '@pb/kit-component-field-description';
import Label from '@pb/kit-component-label';
import {Textarea} from '@pb/kit-component-textarea-v2';

export const MAX_REASON_LENGTH = 64;
const REASON_COUNTER_THRESHOLD = 45;
export const isValidReason = (reason: string) => Boolean(reason.trim()) && reason.trim().length <= MAX_REASON_LENGTH;

type Props = {
    reason: string,
    onChange: (reason: string) => void,
    pending: boolean,
};

export const ReasonField = ({reason, onChange, pending}: Props) => {
    const reasonId = useId();
    const reasonDescriptionId = useId();
    const reasonLength = reason.trim().length;
    const remainingCharacters = MAX_REASON_LENGTH - reasonLength;
    const showReasonCounter = reasonLength >= REASON_COUNTER_THRESHOLD;
    const reasonTooLong = remainingCharacters < 0;

    return (
        <>
            <Label htmlFor={reasonId}><RequiredMark label="Reason"/></Label>
            <Textarea
                id={reasonId}
                aria-describedby={showReasonCounter ? reasonDescriptionId : undefined}
                color={reasonTooLong ? 'ERROR' : 'DEFAULT'}
                autoFocus={true}
                required={true}
                rows={5}
                maxLength={64}
                value={reason}
                resizable={false}
                disabled={pending}
                placeholder="Enter a reason for these changes"
                onChange={event => onChange(event.target.value)}
            />
            {showReasonCounter ? (
                <FieldDescription
                    id={reasonDescriptionId}
                    color={reasonTooLong ? FieldDescriptionTypes.ERROR : FieldDescriptionTypes.DEFAULT}>
                    Characters remaining: {remainingCharacters}
                </FieldDescription>
            ) : null}
        </>
    );
};
